module.exports = __webpack_public_path__ + "img/main_3.e304d807.png";